/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhSecurity.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhSecurity-view">
        <Helmet>
          <title>系統安全 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhSecurity-first">
          <div className="ZhSecurity-content">
            <div className="ZhSecurity-cardContainer">
              <div className="ZhSecurity-cardIcn" />
              <div className="ZhSecurity-heading">付款處理</div>
            </div>

            <div className="ZhSecurity-stripeContainer">
              <div className="ZhSecurity-stripeLogo" />
              <div className="ZhSecurity-txt">
                CheckPlus 透過 Stripe 處理我們的所有信用卡交易。
                <Link to="/ZhStripe">
                  <div className="ZhSecurity-learnmoreContainer">
                    <div className="ZhSecurity-learnmore">進一步了解</div>
                    <div className="ZhSecurity-arrow" />
                  </div>
                </Link>
              </div>
            </div>

            <div className="ZhSecurity-hsbcContainer">
              <div className="ZhSecurity-hsbcLogo" />
              <div className="ZhSecurity-txt">
                CheckPlus 與 HSBC 滙豐合作， 令捐款者可以在平台上透過 PayMe
                付款或捐款。
              </div>
            </div>
          </div>
        </div>

        <div className="ZhSecurity-second">
          <div className="ZhSecurity-content">
            <div className="ZhSecurity-serverContainer">
              <div className="ZhSecurity-serverIcn" />
              <div className="ZhSecurity-heading">數據處理</div>
            </div>

            <div className="ZhSecurity-stripeContainer">
              <div className="ZhSecurity-awsLogo" />
              <div className="ZhSecurity-txt">
                CheckPlus 使用 Amazon Web Services（AWS） 並在符合 ISO27001
                的安全標準下運行我們服務的數據。
              </div>
              <div className="ZhSecurity-tickContainer">
                <div className="ZhSecurity-tickIcn" />
                <div className="ZhSecurity-tickTxt">HTTPS</div>
              </div>
              <div className="ZhSecurity-tickContainer">
                <div className="ZhSecurity-tickIcn" />
                <div className="ZhSecurity-tickTxt">SSL</div>
              </div>
              <div className="ZhSecurity-tickContainer">
                <div className="ZhSecurity-tickIcn" />
                <div className="ZhSecurity-tickTxt">ISO27001 Certified</div>
              </div>
            </div>
          </div>
        </div>

        <div className="ZhSecurity-footer">
          <div className="ZhSecurity-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhSecurity-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhSecurity-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhSecurity-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhSecurity-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhSecurity-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhSecurity-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhSecurity;
